import React, { useCallback } from "react";
import { Select, Container } from "@sanity/ui";
import { StringInputProps, set, unset } from "sanity";

const HexColorInput: React.FC<StringInputProps> = (props) => {
  const { onChange, value = "", elementProps } = props;

  const handleChange: React.FormEventHandler<HTMLSelectElement> = useCallback(
    (event) => {
      const inputValue = event.currentTarget.value;
      onChange(inputValue ? set(inputValue) : unset());
    },
    [onChange]
  );

  return (
    <Container>
      <Select {...elementProps} onChange={handleChange} value={value || ""}>
        <option value={"c84456"} className={"otium-suite-color"}>
          Otium (C84456)
        </option>

        <option value={"8da27e"} className={"owner-suite-color"}>
          Owner (8da27e)
        </option>

        <option value={"ada4ad"} className={"grand-suite-color"}>
          Grand (ada4ad)
        </option>

        <option value={"E5A4A8"} className={"master-suite-color"}>
          Master (E5A4A8)
        </option>

        <option value={"948EB4"} className={"signature-suite-color"}>
          Signature (948EB4)
        </option>

        <option value={"d38877"} className={"royal-suite-color"}>
          Royal (d38877)
        </option>

        <option value={"e5c78d"} className={"silver-suite-color"}>
          Silver (e5c78d)
        </option>

        <option value={"B9E5FB"} className={"junior-grande-suite-color"}>
          Junior Grande (B9E5FB)
        </option>

        <option value={"55C2B8"} className={"premium-medallion-suite-color"}>
          Premium Medallion (55C2B8)
        </option>

        <option value={"dcd3de"} className={"medallion-suite-2-color"}>
          Medallion (dcd3de)
        </option>

        <option value={"C9E4BB"} className={"premium-veranda-suite-color"}>
          Premium Veranda (C9E4BB)
        </option>

        <option value={"77ccca"} className={"deluxe-veranda-suite-color"}>
          Deluxe Veranda (77ccca)
        </option>

        <option value={"f8eab3"} className={"superior-veranda-suite-color"}>
          Superior Veranda (f8eab3)
        </option>

        <option value={"aeafb0"} className={"classic-veranda-suite-color"}>
          Classic Veranda (aeafb0)
        </option>

        <option value={"BD9554"} className={"panorama-suite-color"}>
          Panorama (BD9554)
        </option>

        <option value={"33A3DC"} className={"veranda-suite-color"}>
          Veranda (33A3DC)
        </option>

        <option value={"DFC3DE"} className={"vista-suite-color"}>
          Vista (DFC3DE)
        </option>

        <option value={"FCBB76"} className={"view-suite-color"}>
          View (FCBB76)
        </option>

        <option value={"F69679"} className={"explorer-suite-color"}>
          Explorer (F69679)
        </option>

        <option value={"99C49F"} className={"adventure-suite-color"}>
          Adventure (99C49F)
        </option>

        <option value={"E8EFF9"} className={"new-vista-suite-color"}>
          New - Vista (E8EFF9)
        </option>

        <option value={"BED9F2"} className={"new-panorama-suite-color"}>
          New - Panorama (BED9F2)
        </option>

        <option value={"F4E4DF"} className={"new-veranda-suite-color"}>
          New - Veranda (F4E4DF)
        </option>

        <option value={"FBD0D0"} className={"new-classic-veranda-suite-color"}>
          New - Classic Veranda (FBD0D0)
        </option>

        <option value={"EDA796"} className={"new-superior-veranda-suite-color"}>
          New - Superior Veranda (EDA796)
        </option>

        <option value={"DD818B"} className={"new-deluxe-veranda-suite-color"}>
          New - Deluxe Veranda (DD818B)
        </option>

        <option value={"E36D5A"} className={"new-premium-veranda-suite-color"}>
          New - Premium Veranda (E36D5A)
        </option>

        <option value={"E0F1E6"} className={"new-junior-grande-suite-color"}>
          New - Junior Grande (E0F1E6)
        </option>

        <option value={"B7E2E0"} className={"new-signature-suite-color"}>
          New - Signature (B7E2E0)
        </option>

        <option value={"9BCDBB"} className={"new-silver-suite-color"}>
          New - Silver (9BCDBB)
        </option>

        <option value={"6CB2AC"} className={"new-medallion-suite-color"}>
          New - Medallion (6CB2AC)
        </option>

        <option
          value={"459B88"}
          className={"new-premium-medallion-suite-color"}
        >
          New - Premium Medallion (459B88)
        </option>

        <option value={"EAE6F4"} className={"new-otium-suite-color"}>
          New - Otium (EAE6F4)
        </option>

        <option value={"CBD4F7"} className={"new-master-suite-color"}>
          New - Master (CBD4F7)
        </option>

        <option value={"C3B0D6"} className={"new-owner-suite-color"}>
          New - Owner (C3B0D6)
        </option>

        <option value={"9696CA"} className={"new-grand-suite-color"}>
          New - Grand (9696CA)
        </option>

        <option value={"9B7BC9"} className={"villa-royal-suite-color"}>
          Villa Royal (9B7BC9)
        </option>
      </Select>

      <svg width="100" height="100">
        <circle r="20" cx="25" cy="55" fill={`#${value}`} />
      </svg>
    </Container>
  );
};

export default HexColorInput;
